import { environment } from '@environments/environment';
import { RegionAvailable } from '@shared/services/language/registry';

export const envConfiguredDidomiNoticeId = (region: RegionAvailable) =>
  environment.domains[region].didomiNoticeId ?? '';
